import createClient, { type HeadersOptions } from "openapi-fetch"
import type { paths } from "~/types/api/augwa"

type OverridePaths = {
    [K in keyof paths]: paths[K] extends {
        [M in keyof paths[K]]: paths[K][M] extends {
            parameters: {
                header: {
                    "X-Domain": string;
                } & infer Rest
            }
        } ? Omit<paths[K][M], "parameters"> & {
            parameters: Omit<paths[K][M]["parameters"], "header"> & {
                header?: Rest
            }
        } : paths[K][M]
    } ? {
        [M in keyof paths[K]]: paths[K][M] extends {
            parameters: {
                header: {
                    "X-Domain": string;
                } & infer Rest
            }
        } ? Omit<paths[K][M], "parameters"> & {
            parameters: Omit<paths[K][M]["parameters"], "header"> & {
                header?: Rest
            }
        } : paths[K][M]
    } : paths[K]
}

export default () => {
    const $config = useRuntimeConfig()
    const route = useRoute()

    const headers: HeadersOptions = {}

    if (route.params.domain) {
        headers['X-Domain'] = route.params.domain as string
    }

    return createClient<OverridePaths>({
        baseUrl: $config.public.app.apiEndpoint,
        headers,
    })
}